import { Quote } from "lucide-react";
import { useLang } from "@/i18n";

export default function About() {
  const { t } = useLang();
  return (
    <section id="a-propos" className="relative py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-[5fr_6fr]">
        <div className="relative mx-auto w-full max-w-md">
          <div className="absolute -inset-4 rounded-sm border border-[#A87C4F]/25" />
          <div className="absolute -left-2 -top-2 h-10 w-10 border-l-2 border-t-2 border-[#A87C4F]" />
          <div className="absolute -bottom-2 -right-2 h-10 w-10 border-b-2 border-r-2 border-[#A87C4F]" />
          <img
            src="/assets/valeria-portrait.jpg"
            alt={t.about.imgAlt}
            data-testid="valeria-portrait-image"
            className="relative aspect-[4/5] w-full rounded-sm object-cover"
          />
          <div className="card-lux absolute -bottom-8 -right-4 rounded-md px-6 py-4 text-center backdrop-blur-md sm:-right-8">
            <p className="font-display text-3xl font-semibold text-[#6E4E2E]">18+</p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#948678]">
              {t.about.badge}
            </p>
          </div>
        </div>

        <div>
          <p className="eyebrow" data-testid="about-eyebrow">{t.about.eyebrow}</p>
          <h2 className="mt-5 font-display text-3xl font-semibold tracking-tight sm:text-4xl" data-testid="about-title">
            Valeria <span className="gold-gradient-text italic">Dragneva</span>
          </h2>
          <p className="mt-2 text-sm uppercase tracking-[0.2em] text-[#948678]">
            {t.about.role}
          </p>

          <p className="mt-7 text-base leading-relaxed text-[#5F5647]">
            {t.about.bio1}
          </p>
          <p className="mt-4 text-base leading-relaxed text-[#5F5647]">
            {t.about.bio2a}
            <span className="font-semibold text-[#856237]">{t.about.passion}</span>
            {t.about.bio2b}
          </p>

          <div className="mt-9">
            <p className="mb-4 text-[11px] uppercase tracking-[0.24em] text-[#948678]">
              {t.about.langLabel}
            </p>
            <div className="flex flex-wrap gap-3">
              {t.about.languages.map((l) => (
                <div
                  key={l.code}
                  data-testid={`language-badge-${l.code.toLowerCase()}`}
                  className="flex items-center gap-2.5 rounded-sm border border-[#A87C4F]/30 bg-white/60 px-4 py-2"
                >
                  <span className="font-mono-eyebrow text-xs font-semibold text-[#856237]">{l.code}</span>
                  <span className="text-xs text-[#5F5647]">{l.name}</span>
                </div>
              ))}
            </div>
          </div>

          <blockquote className="relative mt-10 border-l-2 border-[#A87C4F]/60 pl-6">
            <Quote size={20} className="absolute -left-2.5 -top-1 bg-[#FAF8F4] text-[#A87C4F]" />
            <p className="font-display text-lg italic leading-relaxed text-[#6E4E2E]">
              {t.about.quote}
            </p>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
